import { css } from 'linaria';

export const modalContentMobile = css`
  && > div {
    min-height: 72px !important;
  }
`;

export const modalContentTablet = css`
  && > div {
    min-height: 46px !important;
  }
`;

export const modalButtonMobile = css`
  width: 100%;
`;
